import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

@NgModule({ imports: [CommonModule], providers: [HttpClient, provideHttpClient(withInterceptorsFromDi())] })
export class AbcCoreConfigurationModule {}
